export default "__VITE_ASSET__48cdd92a__"